<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
	[showCarousel]="!canReadContactsRestricted()"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditContacts()"
	(editClicked)="openEdit()"
	[disableEditButton]="isEditDisabled() || isFrozen()"
	[disableEditTranslationKey]="editDisabledReason()"
	[disableEditTranslationParams]="disableEditTranslationParams()"
>
	{{ 'contact.details.title' | transloco: { date: contact()?.contactedAt | date: dateDisplayFormat } }}
</lvr-heading>

<section class="grid" role="region">
	<table>
		<!-- Took place on / Contact type -->
		<tr>
			<th scope="col">{{ 'contact.details.took_place_on' | transloco }}</th>
			<th scope="col" *lvrPermission="readPermissions">
				{{ 'contact.details.contact_type' | transloco }}
			</th>
		</tr>
		<tr>
			<td>{{ contact()?.contactedAt | date: dateDisplayFormat }}</td>
			<td *lvrPermission="readPermissions">{{ contact()?.contactType?.remark }}</td>
		</tr>

		<!-- Keyword / Remark -->
		<tr>
			<th scope="col">{{ 'contact.details.keyword' | transloco }}</th>
			<th scope="col" *lvrPermission="readPermissions">
				{{ 'contact.details.remark' | transloco }}
			</th>
		</tr>
		<tr>
			<td>{{ contact()?.keyword }}</td>
			<td *lvrPermission="readPermissions" class="contact-remark">{{ contact()?.remark }}</td>
		</tr>

		<!-- Confidential / Client participated -->
		<tr>
			<th scope="col">{{ 'contact.details.confidential' | transloco }}</th>
			<th scope="col">{{ 'contact.details.client_participated' | transloco }}</th>
		</tr>
		<tr>
			<td>
				{{ contact()?.confidential ? ('contact.details.true' | transloco) : ('contact.details.false' | transloco) }}
			</td>
			<td>
				{{ isClientParticipant() ? ('contact.details.true' | transloco) : ('contact.details.false' | transloco) }}
			</td>
		</tr>

		<!-- Participants / Tasks -->
		<tr *lvrPermission="readPermissions">
			<th scope="col">{{ 'contact.details.participants' | transloco }}</th>
			<th scope="col">{{ 'contact.details.tasks' | transloco }}</th>
		</tr>
		<tr *lvrPermission="readPermissions">
			<td>
				<ul>
					@for (participant of contact()?.participants ?? []; track trackItem(participant)) {
						<li class="participant">
							<div>
								<p>{{ participant.item.firstName + ' ' + participant.item.name }}</p>
								<span class="relation">{{ mapPersonTypeToKey(participant.personTypeId) | transloco }}</span>
							</div>
							@if (isContactTypeAnEmail(contact())) {
								<lvr-send-email-button
									[participantName]="participant.item.firstName + ' ' + participant.item.name"
									[subject]="contact()?.keyword ?? ''"
									[body]="contact()?.remark ?? ''"
									[contactPoints]="participant.contactPoints"
								></lvr-send-email-button>
							}
						</li>
					}
				</ul>
			</td>
			<td>
				<ul>
					@for (task of contact()?.tasks ?? []; track $index) {
						<li>
							{{ task.description }}
						</li>
					}
				</ul>
			</td>
		</tr>

		@if (canReadContactDocuments()) {
			<!-- Documents -->
			<tr>
				<th scope="col" colspan="2">{{ 'contact.details.documents' | transloco }}</th>
			</tr>
			<tr>
				<td colspan="2">
					<ul>
						@for (doc of contact()?.documents ?? []; track doc.id) {
							<li>
								@if (buildDocumentEntryFromContact(doc); as entry) {
									<lvr-document-item [document]="entry" (open)="onFileClick(doc)"></lvr-document-item>
								}
							</li>
						}
					</ul>
				</td>
			</tr>
		}
	</table>
</section>
